import { ReactNode } from 'react';

import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useTheme
} from '@chakra-ui/react';

import { PickTimeTabType } from 'types';

interface TabData {
  label: string;
  content: ReactNode;
}

interface BoxTabsProps {
  tabs: TabData[];
  onTabChange: (idx: PickTimeTabType) => void;
  isHiddenTabs: boolean;
}

const BoxTabs = ({ tabs, onTabChange, isHiddenTabs }: BoxTabsProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepTime: { boxTabs }
        }
      }
    }
  } = useTheme();

  return (
    <Tabs
      w={{ base: 'calc(100% + 30px)', md: '100%' }}
      variant='enclosed'
      isFitted
      bg='transparent'
      mx={{ base: '-15px', md: 0 }}
      onChange={onTabChange}
    >
      <TabList
        border='none'
        alignItems={{ base: 'stretch', md: 'flex-end' }}
        gap='5px'
        mx='10px'
        display={{ base: isHiddenTabs ? 'none' : 'flex', md: 'flex' }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.label}
            bg={boxTabs.tabBackground}
            fontSize='14px'
            py='11px'
            textTransform='uppercase'
            letterSpacing='0.6px'
            border='none'
            sx={{
              '&[aria-selected="true"]': {
                fontSize: { base: '14px', md: '16px' },
                bg: boxTabs.selectedTabBackground,
                color: boxTabs.selectedTabTextColor
              }
            }}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>

      <TabPanels
        position='relative'
        border={{ md: '4px solid' }}
        borderTop={{
          base: isHiddenTabs ? 'none' : '4px solid',
          md: '4px solid'
        }}
        borderColor={{
          base: boxTabs.tabPanelBorderColor,
          md: boxTabs.tabPanelBorderColor
        }}
        borderRadius={{ md: '6px' }}
        bg={boxTabs.tabPanelBackground}
        zIndex={2}
      >
        {tabs.map((tab) => (
          <TabPanel key={tab.label} p={0}>
            {tab.content}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default BoxTabs;
